import styled from "styled-components";
import { FlexWrapper } from "../AdAssistant.styled";
import { Button } from "../../../Components/ContinueButton/ContinueButton.styled";

export const AdAssistantOverviewWrapper = styled.div`
  display: flex;
  padding: 8.046px 16.092px 16.092px 16.092px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16.092px;
  border-radius: 8.046px;
  background: #dce0fc;
`;

export const AdTitleEditWrapper = styled(FlexWrapper)`
  color: #7a89f4;
  font-size: 12px;
  font-weight: 600;
`;

export const EmptyButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  line-height: 0;
`;

export const QuestionsButton = styled(Button)`
  min-width: 150px;
  background: #d4d8f9;
  border: 1px solid #d4d8f9;

  &:hover {
    background: #d4d8f9;
    border: 1px solid #d4d8f9;
  }
`;

export const PublishButton = styled(Button)`
  min-width: 150px;
  background: var(--primary-green-500);
  color: var(--primary-white);
  border: none;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 4px;
  font-weight: bold;

  &:hover {
    background: var(--primary-green-500);
    color: var(--primary-white);
    border: none;
  }

  &:disabled {
    cursor: not-allowed;
  }

  @media screen and (min-width: 1920px) and (min-device-pixel-ratio: 2),
    screen and (min-width: 1920px) and (min-resolution: 192dpi) {
    width: auto !important;
  }
`;

export const CampaignActive = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 16px;
  width: 100%;
  height: 100%;
  background: #67e4b01a;
  color: var(--primary-black);
  border: 1px solid var(--primary-green-500);
  border-radius: 4px;
  padding: 20px;
  font-size: var(--fs-base);
  line-height: var(--lh-base);
`;

export const CampaignActiveText = styled.span`
  color: var(--primary-grey);
`;
